import { z } from 'zod';

export function formatarData(isoDate: string) {
  const data = new Date(isoDate);
  const dia = String(data.getDate()).padStart(2, '0');
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const ano = data.getFullYear();
  return `${dia}/${mes}/${ano}`;
}

export function dataValida(isoDate: string): boolean {
  const data = new Date(isoDate);
  return data instanceof Date && !isNaN(data.getTime());
}

const passwordSchema = z.string()
  .min(5, { message: "No mínimo 5 caracteres." })
  .regex(/(?=.*[A-Z])/, { message: "Pelo menos uma letra maiúscula." })
  .regex(/(?=.*[^\p{L}\p{N}])/u, { message: "Pelo menos um caractere especial." });

/*  function formataMensagemValidacao(regra : string[]) : string {
  const resp = "A senha deve conter:\n " + regra.join(" \n") 
 } */

export function validarSenha(senha: string) {
  const result = passwordSchema.safeParse(senha);

  if (result.success) {
    return { status: true, error: null };
  } else {
    // Coletar todas as mensagens de erro
    const errorMessages = result.error.issues.map((issue) => issue.message);
    return { status: false, error: "A senha deve conter:\n " + errorMessages.join(" \n") };
  }
};